@if (hasAnySlot) {
  <nav class="mobile-bottom-nav" [class.mobile-bottom-nav--compact]="isCompactBar">
    @if (showHint) {
      <div class="mobile-bottom-nav__hint" (click)="dismissHint.emit()">
        <div class="mobile-bottom-nav__hint-bubble">
          {{ 'mobileNav.customizeOnboardingHint' | translate }}
        </div>
        <i class="fa fa-hand-pointer-o mobile-bottom-nav__hint-pointer"></i>
      </div>
    }

    <ng-template #slotItem let-slot>
      @if (slot.isAction) {
        <button
          type="button"
          class="mobile-bottom-nav__item"
          longPress
          (longPress)="longPress.emit()"
          (click)="actionClick.emit(slot)"
          (contextmenu)="$event.preventDefault()">
          <shared-quick-access-icon
            [page]="slot"
            faClass="mobile-bottom-nav__fa-icon"></shared-quick-access-icon>
          <span class="mobile-bottom-nav__label">
            {{ slot.customLabel || (slot.titleKey | translate) }}
          </span>
        </button>
      } @else {
        <a
          class="mobile-bottom-nav__item"
          [routerLink]="suppressNavigation ? null : [slot.path]"
          routerLinkActive="active"
          longPress
          (longPress)="longPress.emit()"
          (contextmenu)="$event.preventDefault()">
          <shared-quick-access-icon
            [page]="slot"
            faClass="mobile-bottom-nav__fa-icon"></shared-quick-access-icon>
          <span class="mobile-bottom-nav__label">
            {{ slot.customLabel || (slot.titleKey | translate) }}
          </span>
        </a>
      }
    </ng-template>

    <div class="mobile-bottom-nav__bar">
      @for (slot of leadingSlots; track slot.id) {
        <ng-container *ngTemplateOutlet="slotItem; context: { $implicit: slot }"></ng-container>
      }

      @if (middleSlot; as middle) {
        <span class="mobile-bottom-nav__spacer">
          <span class="mobile-bottom-nav__bump"></span>

          @if (middle.isAction) {
            <button
              type="button"
              class="mobile-bottom-nav__fab"
              longPress
              (longPress)="longPress.emit()"
              (click)="actionClick.emit(middle)">
              <shared-quick-access-icon [page]="middle"></shared-quick-access-icon>
            </button>
          } @else {
            <a
              class="mobile-bottom-nav__fab"
              [routerLink]="suppressNavigation ? null : [middle.path]"
              longPress
              (longPress)="longPress.emit()"
              (contextmenu)="$event.preventDefault()">
              <shared-quick-access-icon [page]="middle"></shared-quick-access-icon>
            </a>
          }

          <span class="mobile-bottom-nav__label">
            {{ middle.customLabel || (middle.titleKey | translate) }}
          </span>
        </span>
      }

      @for (slot of trailingSlots; track slot.id) {
        <ng-container *ngTemplateOutlet="slotItem; context: { $implicit: slot }"></ng-container>
      }
    </div>
  </nav>
}
